import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponsibleModel } from '../models/responsible.model';
import { AppService } from '../app.service';
import Routes from '../helpers/routes';
import Auth from '../helpers/auth';
import { CreditCardModel } from '../models/creditCard.model';


@Injectable()
export class ResponsibleService extends AppService<ResponsibleModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async get() {
    const result = await this.getAsync(`Responsible/${Auth.getUser().id}`);
    return result;
  }

  async getCreditCards(): Promise<any> {
    const result = await this.getAsync(`Cartao/BuscarCartoesUsuario`);
    return result;
  }

  async register(responsible: ResponsibleModel) {
    const result = await this.postAsync(`Responsible`, responsible);
    return result;
  }

  async updateDefaultCard(creditCard: CreditCardModel) {
    const result = await this.putAsync(
      `Responsible/${Auth.getUser().id}/creditCard/${creditCard.id}/default`
    );
    return result;
  }

  async deleteCreditCard(id: string) {
    const result = await this.postAsync(`Cartao/ExcluirCartao/${id}`);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/responsible.service.ts